// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#ffb601","fieldWrapper":"NumberInput_fieldWrapper__15imm","numberInput":"NumberInput_numberInput__x_PQJ","endText":"NumberInput_endText__13vcm"};